import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
import { API_PATH } from "../../utils/apis";

const initialState = {
  isLoading: false,
  error: false,
  transfers: [],
  summary: {},
  total: 0,
};

const slice = createSlice({
  name: "transfer",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // GET PRODUCTS
    getSuccess(state, action) {
      state.isLoading = false;
      state.transfers = action.payload.data;
      state.summary = action.payload.summary;
      state.total = parseInt(action.payload.total, 10);
    },
    //  SORT & FILTER PRODUCTS
    sortBy(state, action) {
      state.sortBy = action.payload;
    },

    filter(state, action) {
      state.filters.category = action.payload.category;
    },
  },
});

// Reducer
export default slice.reducer;

export const { filter, sortBy } = slice.actions;

export function getTransfers(page, perpage, order, sortBy) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(API_PATH.bankTransfers, {
        get: "",
        page,
        perpage,
        order,
        sortBy,
      });
      const { status, data, total, summary } = response.data;
      if (status === "success") {
        dispatch(slice.actions.getSuccess({ data, summary, total }));
      } else {
        dispatch(
          slice.actions.hasError(
            new Error(
              "We cannot fetch bank transfers at the moment! Please check back later."
            )
          )
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
